import { render, staticRenderFns } from "./SearchSection.vue?vue&type=template&id=b3b2525a&scoped=true&"
import script from "./SearchSection.vue?vue&type=script&lang=js&"
export * from "./SearchSection.vue?vue&type=script&lang=js&"
import style0 from "./SearchSection.vue?vue&type=style&index=0&id=b3b2525a&prod&scoped=true&lang=css&"
import style1 from "./SearchSection.vue?vue&type=style&index=1&id=b3b2525a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3b2525a",
  null
  
)

export default component.exports